import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/palette.svg'
import BaseIcon from '../../BaseIcon'

const Palette = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 512 512" />
}

Palette.propTypes = {
	className: PropTypes.string,
}

export default Palette
